export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" fill="none" className={className} aria-hidden="true" focusable="false">
    <path
      d="M47 12.5c-8.5-5.5-21-3-23 4-1.9 6.6 8.3 8.4 14.5 10.7 6.3 2.3 6.6 8.6 1.3 12.6-5.9 4.4-15.8 3.6-22-1.6"
      stroke="currentColor"
      strokeWidth="4.6"
      strokeLinecap="round"
    />
    <path
      d="M13.5 52c12 4.8 25.5 3.4 35-4"
      stroke="#FF3B30"
      strokeWidth="2.6"
      strokeLinecap="round"
    />
  </svg>
);

export default function Logo({ light = false, className = "" }) {
  return (
    <span
      className={`inline-flex items-center gap-3 ${light ? "text-paper" : "text-ink"} ${className}`}
      data-testid="logo"
    >
      <LogoMark className="h-9 w-9 md:h-10 md:w-10" />
      <span className="leading-none text-left">
        <span className="block font-display italic text-[22px] tracking-tight">Signature</span>
        <span className="block font-mono text-[9px] uppercase tracking-[0.42em] mt-1 opacity-70">
          Printing
        </span>
      </span>
    </span>
  );
}
